<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Edit Bell</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form>
          <div class="form-group">
            <label>Time</label> <br>
            <input type="text" class="form-control" v-model="day_schedule_item.schedule_time_formatted">
            <small class="form-text text-muted">Must be of the the format hh:mm:ss (am or pm). Example: 10:00:00 am</small>
          </div>
          <div class="form-group">
            <label>Description</label> <br>
            <input type="text" class="form-control" v-model="day_schedule_item.description">
            <small class="form-text text-muted">A short description describing what this bell is for.</small>
          </div>
          <div class="form-group">
            <label for="ddlZones">Zones</label>
            <v-select multiple v-model="zones_selected" :options="zones_for_drop_down" placeholder="Select..."></v-select>
          </div>
          <!-- <div class="form-group">
            <label for="ddlZone">Zone</label>
            <select class="form-control" id="ddlZone" v-model="day_schedule_item.zone_id">
              <option value="0">Select..</option>
              <option v-for="zone in filtered_zones" :key="zone.zone_id" v-bind:value="zone.zone_id">[{{ zone.site.name }}] {{ zone.name }}
              </option>
            </select>
          </div> -->
          <div class="form-group">
            <label for="ddlSoundType">Sound Type</label>
            <select class="form-control" id="ddlSoundType" v-model="day_schedule_item.sound_type_id">
              <option v-for="sound_type in sound_types" :key="sound_type.sound_type_id" v-bind:value="sound_type.sound_type_id">
                {{ sound_type.name }}
              </option>
            </select>
          </div>
          <div v-if="day_schedule_item.sound_type_id === 1">
            <SoundDropDownAndPreview tag="bell" v-model="day_schedule_item.sound"></SoundDropDownAndPreview>
          </div>
          <div class="form-group" v-if="[2,3,4].includes(day_schedule_item.sound_type_id)">
            <label for="ddlPlaylist">Playlist</label>
            <select class="form-control" id="ddlPlaylist" v-model="day_schedule_item.playlist_id">
              <option value="0">Select..</option>
              <option v-for="playlist in filtered_playlists" :key="playlist.playlist_id" v-bind:value="playlist.playlist_id">
                {{ playlist.name }}
              </option>
            </select>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'DayScheduler' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import SoundDropDownAndPreview from '../../../components/SoundDropDownAndPreview'

export default {
  props: [
    'day_schedule_item_id'
  ],
  data: function () {
    return {
      zones_selected: []
    }
  },
  components: { vSelect, SoundDropDownAndPreview },
  computed: {
    ...mapGetters({
      day_schedule_item: 'singleDayScheduleItem',
      sound_types: 'allSoundTypes',
      playlists: 'allPlaylists',
      scoped_site_id: 'scopedSiteId',
      zones: 'allZones'
    }),
    filtered_playlists: function () {
      return this.playlists.filter(playlist => playlist.site_id === this.scoped_site_id)
    },
    zones_for_drop_down: function () {
      return this.zones
        .filter(
          zone =>
            this.scoped_site_id === 1 || zone.site_id === this.scoped_site_id
        )
        .map(zone => {
          return {
            value: zone.zone_id,
            label: `[${zone.site.name}] ${zone.name}`
          }
        })
    }
  },
  watch: {
    'day_schedule_item.zones' (zones) {
      if (this.zones_selected.length > 0) { return }

      for (let i = 0; i < zones.length; i++) {
        this.zones_selected.push({
          value: zones[i].zone_id,
          label: `[${zones[i].site.name}] ${zones[i].name}`
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getDayScheduleItem', this.day_schedule_item_id)
    this.$store.dispatch('getSoundTypes')
    this.$store.dispatch('getPlaylists')
    this.$store.dispatch('getZones')
  },
  methods: {
    submit () {
      this.day_schedule_item.zones = []

      for (let i = 0; i < this.zones_selected.length; i++) {
        this.day_schedule_item.zones.push({
          zone_id: this.zones_selected[i].value
        })
      }

      let data = {
        day_schedule_item: this.day_schedule_item,
        to_continue: false
      }

      this.$store.dispatch('addEditDayScheduleItem', data)
    }
  }
}
</script>

<style scoped>
</style>
